import React from 'react';
import Input from "@Features/input/inputField/components/Input";

interface InputFieldProps {
    htmlId: string,
    label?: string,
    value: any,
    type?: string,
    isRequired?: boolean,
    placeholder?: string,
    onChange: (...args: any[]) => any,
    onBlur?: (...args: any[]) => any,
    onKeyDown?: (any) => any,
    showError?: boolean,
    errorMessage?: string | React.ReactNode,
    componentClassname?: string,
    labelClassname?: string,
    inputClassname?: string,
}

function InputField(props: InputFieldProps) {
    const {
        htmlId,
        label,
        value,
        type,
        isRequired,
        placeholder,
        onChange,
        onBlur,
        onKeyDown,
        showError,
        errorMessage,
        componentClassname = "",
        labelClassname = "",
        inputClassname = "",
    } = props

    return (
        <div className={componentClassname}>
            {label && (
                <label htmlFor={htmlId} className={labelClassname ?? ""}>
                    {label}
                </label>
            )}
            <Input
                inputClassName={`gb--input-standalone ${inputClassname}`}
                htmlId={htmlId}
                onChange={onChange}
                onKeyDown={onKeyDown}
                value={value}
                placeholder={placeholder ?? label}
                onBlur={onBlur}
                isRequired={isRequired}
                showError={showError}
                errorMessage={errorMessage}
                type={type}
            />
        </div>
    );
}

export default InputField;